import { useState } from 'react';
import {
  NJHeading,
  NJIconButton,
  NJListDeprecated,
  NJListItemDeprecated,
  NJSidebarBrandDeprecated,
  NJSidebarCloseDeprecated,
  NJSidebarDeprecated,
  NJSidebarDividerDeprecated,
  NJSidebarMenuDeprecated,
} from '@engie-group/fluid-design-system-react';

const PRIMARY_NAV = [
  { id: 'networks', icon: 'account_tree', label: 'Networks', active: true },
  { id: 'calculations', icon: 'legend_toggle', label: 'Calculations' },
  { id: 'coreai', icon: 'auto_awesome', label: 'Nemo CoreAI' },
];
const PRIMARY_FOOTER = [
  { id: 'user-guide', icon: 'help_outline', label: 'User guide' },
  { id: 'profile', icon: 'account_circle', label: 'Profile' },
  { id: 'disconnect', icon: 'power_settings_new', label: 'Disconnect' },
];
const SECONDARY_NAV = [
  { id: 'general', icon: 'remove_red_eye', label: 'Général' },
  { id: 'import-export', icon: 'swap_horiz', label: 'Import/export' },
  { id: 'topology', icon: 'view_quilt', label: 'Topologie' },
  { id: 'production', icon: 'factory', label: 'Production' },
  { id: 'plannings', icon: 'date_range', label: 'Plannings' },
  { id: 'optimizations', icon: 'insights', label: 'Optimisations' },
];

const PRIMARY_SIDEBAR_WIDTH_FOLDED = 60;

interface NemoShellProps {
  networkName: string;
  children: React.ReactNode;
}

export default function NemoShell({ networkName, children }: NemoShellProps) {
  const [isPrimaryMenuFolded, setIsPrimaryMenuFolded] = useState(true);

  return (
    <>
      <style>
        {`
          .carto-primary-sidebar {
            position: relative !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            height: 100% !important;
            min-width: 0 !important;
          }
          .carto-primary-sidebar .nj-list-deprecated__item button {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 100% !important;
            gap: 16px;
          }
          .carto-secondary-nav-item li {
            border: none !important;
            border-bottom: none !important;
            box-shadow: none !important;
          }
          .carto-secondary-nav-item li:hover {
            background-color: var(--nj-core-color-blue-alpha-200) !important;
          }
          .carto-secondary-nav-item.active {
            border-left: 3px solid var(--nj-semantic-color-border-brand-primary-default) !important;
          }
          .hidden { display: none !important; }
        `}
      </style>
      <div style={{ display: 'flex', flexDirection: 'row', position: 'absolute', inset: 0, overflow: 'hidden' }}>
        {/* Primary sidebar */}
        <div
          style={{
            width: isPrimaryMenuFolded ? PRIMARY_SIDEBAR_WIDTH_FOLDED : 230,
            flexShrink: 0,
            height: '100%',
            overflow: 'hidden',
            transition: 'width 180ms ease',
          }}
        >
          <NJSidebarDeprecated
            isFolded={isPrimaryMenuFolded}
            className="carto-primary-sidebar"
          >
            <NJSidebarBrandDeprecated
              imageSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='24' viewBox='0 0 80 24'%3E%3Ctext y='18' font-size='18' font-family='Lato,sans-serif' font-weight='700' fill='%230052CC'%3ENeMo%3C/text%3E%3C/svg%3E"
              imageFoldedSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3E%3Crect x='.25' y='.25' width='29.5' height='29.5' rx='5.75' fill='white' stroke='%237FADEF' stroke-width='.5'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.472 16.7C21.472 18.07 21.045 19.34 20.318 20.38H9.747C9.02 19.34 8.593 18.07 8.593 16.7c0-3.558 2.883-6.44 6.44-6.44 1.343 0 2.591.412 3.623 1.116.87-.302 1.882-.636 3.053-1.004C19.033 8.603 16.662 7.5 15.033 7.5 9.952 7.5 5.833 11.62 5.833 16.7c0 2.508 1.003 4.782 2.63 6.442h13.14C23.229 21.482 24.232 19.21 24.232 16.7c0-1.136-.206-2.224-.582-3.228-.855.786-1.614 1.466-2.285 2.051.07.382.107.775.107 1.177zm-8.08.546c.508.88 1.623 1.187 2.49.686.868-.5 2.912-2.212 6.934-6.128-5.402 1.525-7.906 2.44-8.773 2.941-.868.5-1.159 1.62-.651 2.5z' fill='url(%23g)'/%3E%3Cdefs%3E%3ClinearGradient id='g' x1='-2.85' y1='15.16' x2='12' y2='32.62' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2300AAFF'/%3E%3Cstop offset='.97' stop-color='%2323D2B5'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E"
            />
            <NJSidebarMenuDeprecated isFolded>
              <>
                {PRIMARY_NAV.map((item) => (
                  <li
                    key={item.id}
                    className={`nj-list-deprecated__item nj-list-deprecated__item--right-border nj-list-deprecated__item--clickable${item.active ? ' nj-list-deprecated__item--active' : ''}`}
                    style={{ overflow: 'hidden' }}
                  >
                    <button type="button" aria-label={item.label} style={{ overflow: 'hidden' }}>
                      <span
                        className="material-icons nj-icon-material nj-icon-material--md nj-icon-material--grey nj-list-deprecated__item-icon"
                        aria-hidden="true"
                      >
                        {item.icon}
                      </span>
                      <div className={`nj-list-deprecated__item-content${isPrimaryMenuFolded ? ' hidden' : ''}`} style={{ color: 'var(--nj-core-color-grey-600)' }}>
                        {item.label}
                      </div>
                    </button>
                  </li>
                ))}
              </>
            </NJSidebarMenuDeprecated>

            <NJSidebarMenuDeprecated isFolded isFooterNav>
              <>
                <li
                  className="nj-list-deprecated__item nj-list-deprecated__item--right-border nj-list-deprecated__item--clickable"
                  style={{ overflow: 'hidden' }}
                >
                  <button type="button" aria-label="Old version" style={{ overflow: 'hidden' }}>
                    <span className="material-icons nj-icon-material nj-icon-material--md nj-icon-material--grey nj-list-deprecated__item-icon" aria-hidden="true">history</span>
                    <div className={`nj-list-deprecated__item-content${isPrimaryMenuFolded ? ' hidden' : ''}`} style={{ color: 'var(--nj-core-color-grey-600)' }}>Old version</div>
                  </button>
                </li>
                <NJSidebarDividerDeprecated />
                {PRIMARY_FOOTER.map((item) => (
                  <li
                    key={item.id}
                    className="nj-list-deprecated__item nj-list-deprecated__item--right-border nj-list-deprecated__item--clickable"
                    style={{ overflow: 'hidden' }}
                  >
                    <button type="button" aria-label={item.label} style={{ overflow: 'hidden' }}>
                      <span className="material-icons nj-icon-material nj-icon-material--md nj-icon-material--grey nj-list-deprecated__item-icon" aria-hidden="true">{item.icon}</span>
                      <div className={`nj-list-deprecated__item-content${isPrimaryMenuFolded ? ' hidden' : ''}`} style={{ color: 'var(--nj-core-color-grey-600)' }}>{item.label}</div>
                    </button>
                  </li>
                ))}
              </>
            </NJSidebarMenuDeprecated>

            <NJSidebarCloseDeprecated onClick={() => setIsPrimaryMenuFolded((p) => !p)}>
              <span style={{ color: 'var(--nj-core-color-grey-600)' }}>
                {isPrimaryMenuFolded ? 'Expand' : 'Reduce'}
              </span>
            </NJSidebarCloseDeprecated>
          </NJSidebarDeprecated>
        </div>

        {/* Right column */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
          {/* App header bar */}
          <header style={{
            height: 48,
            borderBottom: '1px solid var(--nj-core-color-grey-300)',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            background: 'var(--nj-semantic-color-background-neutral-primary-default)',
            flexShrink: 0,
            paddingRight: 16,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <div style={{ fontSize: 12, padding: '8px 12px 0', background: 'var(--nj-semantic-color-background-neutral-tertiary-translucent-default)', alignSelf: 'stretch', display: 'flex', alignItems: 'flex-start' }}>
                <span>Study</span>
              </div>
              <div style={{ margin: '0 16px', borderLeft: '1px dashed var(--nj-core-color-grey-300)', alignSelf: 'stretch' }} />
              <NJIconButton icon="search" label="search" variant="tertiary" />
              <NJIconButton icon="more_time" label="time" variant="tertiary" />
              <button type="button" style={{ fontSize: 16, border: 'none', cursor: 'pointer', color: 'var(--nj-semantic-color-text-neutral-tertiary-default)', background: 'transparent' }}>FR</button>
              <NJIconButton icon="keyboard_arrow_down" label="lang" variant="tertiary" scale="sm" />
            </div>
          </header>

          {/* Content row: secondary nav + main */}
          <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
            {/* Secondary sidebar */}
            <nav style={{ width: 230, background: 'var(--nj-semantic-color-background-neutral-primary-default)', borderRight: '1px solid var(--nj-semantic-color-border-neutral-minimal-default)', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
              <div style={{ padding: '24px 0 12px 24px', display: 'flex', alignItems: 'center', gap: 8 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ flexShrink: 0 }}>
                  <g clipPath="url(#clip_net)">
                    <path d="M17.7143 2H6.28571C5.02857 2 4.01143 3 4.01143 4.22222L4 22L12 18.6667L20 22V4.22222C20 3 18.9714 2 17.7143 2Z" fill="#007ACD" />
                    <path d="M14.9844 11.6357C14.9843 11.6337 14.9841 11.6318 14.9839 11.6299C14.9083 10.8171 14.4723 8.52986 11.9999 6C9.52643 8.53123 9.09116 10.8194 9.01576 11.6311L9.01551 11.6341C8.99751 11.8292 9.00007 11.9385 9.00019 11.9436V11.9448C9.00019 13.6321 10.3432 15 12 15C13.6568 15 15 13.6321 15 11.9448L14.9998 11.9424C15 11.9323 15.0019 11.8249 14.9844 11.6357Z" fill="white" />
                  </g>
                  <defs><clipPath id="clip_net"><rect width="24" height="24" fill="white" /></clipPath></defs>
                </svg>
                <NJHeading scale="sm" as="h2" style={{ margin: 0, fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {networkName}
                </NJHeading>
              </div>
              <NJListDeprecated style={{ paddingTop: 12, paddingBottom: 16 }}>
                <>
                  {SECONDARY_NAV.filter((item) => item.id !== 'optimizations').map((item) => (
                    <div key={item.id} className="carto-secondary-nav-item">
                      <NJListItemDeprecated icon={{ name: item.icon, size: 'md' }} type="link" className="border-none">
                        {item.label}
                      </NJListItemDeprecated>
                    </div>
                  ))}
                  <div className="carto-secondary-nav-item active" style={{ position: 'relative' }}>
                    <span aria-hidden="true" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 3, backgroundColor: 'var(--nj-semantic-color-border-brand-primary-default)' }} />
                    <NJListItemDeprecated icon={{ name: 'insights', size: 'md' }} type="link" className="border-none" style={{ fontWeight: 600, color: 'var(--nj-semantic-color-text-brand-primary-default)' }}>
                      Optimisations
                    </NJListItemDeprecated>
                  </div>
                </>
              </NJListDeprecated>
            </nav>

            {/* Main content */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: 'var(--nj-semantic-color-background-neutral-secondary-default)' }}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
